// extracted by mini-css-extract-plugin
module.exports = {"main":"Subsidies_main__2xUNS","note":"Subsidies_note__31s49"};